import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import PropTypes from 'prop-types'
import Link from '../common/Link'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`

const InterimControls = props => {
  const { resourceType, entity, year, isEditable, onAdd, onRemove } = props
  if (resourceType === 'Business' && entity.borrowerType === 'oc' && isEditable) {
    const { fiscalYears, applicableYears } = entity
    const interimCount = fiscalYears.filter(fy => fy.period === 'interim').length
    const lastYear = applicableYears[applicableYears.length - 1]
    const lastPossibleInterim = moment().year() + 1 === lastYear + 1
    if (year === lastYear) {
      return (
        <Container>
          {interimCount < 2 && !lastPossibleInterim && <Link id="add_interim" onClick={onAdd}>Add Interim</Link>}
          {interimCount >= 1 && <Link id="remove_interim" onClick={onRemove}>Remove Interim</Link>}
        </Container>
      )
    }
  }
  return null
}

InterimControls.propTypes = {
  entity: PropTypes.shape({
    fiscalYears:     PropTypes.arrayOf(PropTypes.object),
    applicableYears: PropTypes.arrayOf(PropTypes.number)
  }),
  isEditable:   PropTypes.bool,
  onAdd:        PropTypes.func,
  onRemove:     PropTypes.func,
  resourceType: PropTypes.string.isRequired,
  year:         PropTypes.number.isRequired
}

export default InterimControls
